/*
 * Sonatype Nexus (TM) Open Source Version
 * Copyright (c) 2008-present Sonatype, Inc.
 * All rights reserved. Includes the third-party code listed at http://links.sonatype.com/products/nexus/oss/attributions.
 *
 * This program and the accompanying materials are made available under the terms of the Eclipse Public License Version 1.0,
 * which accompanies this distribution and is available at http://www.eclipse.org/legal/epl-v10.html.
 *
 * Sonatype Nexus (TM) Professional Version is available from Sonatype, Inc. "Sonatype" and "Sonatype Nexus" are trademarks
 * of Sonatype, Inc. Apache Maven is a trademark of the Apache Software Foundation. M2eclipse is a trademark of the
 * Eclipse Foundation. All other trademarks are the property of their respective owners.
 */

import { ENDPOINTS, parseApiError, restClient } from '../../../../../../interface/api';
import ExtJS from '../../../../../../interface/ExtJS';
import type { FilterSection, QuarantinePage, QuarantineQuery, QuarantineSummary } from './quarantine.types';
import { QUARANTINE_STRINGS as STRINGS } from './quarantine.strings';

const FILTER_SECTIONS: FilterSection[] = ['severity', 'policy', 'ecosystem', 'repository'];

export function buildQuarantineParams(query: QuarantineQuery, paged: boolean): URLSearchParams {
  const params = new URLSearchParams();
  for (const section of FILTER_SECTIONS) {
    for (const value of query.filters[section]) {
      params.append(section, value);
    }
  }
  const search = query.search.trim();
  if (search) params.set('search', search);
  params.set('sortBy', query.sortBy);
  params.set('asc', String(query.asc));
  if (paged) {
    params.set('page', String(query.page));
    params.set('pageSize', String(query.pageSize));
  }
  return params;
}

async function getJson<T>(url: string, fallback: string): Promise<T> {
  try {
    return await restClient.get<T>(url);
  } catch (error) {
    throw new Error(parseApiError(error).message || fallback);
  }
}

export function fetchQuarantine(query: QuarantineQuery): Promise<QuarantinePage> {
  return getJson<QuarantinePage>(
    `${ENDPOINTS.FIREWALL_QUARANTINE}?${buildQuarantineParams(query, true).toString()}`,
    STRINGS.errors.loadList
  );
}

export function fetchQuarantineSummary(): Promise<QuarantineSummary> {
  return getJson<QuarantineSummary>(ENDPOINTS.FIREWALL_QUARANTINE_SUMMARY, STRINGS.errors.loadSummary);
}

export function quarantineExportUrl(query: QuarantineQuery): string {
  return ExtJS.urlOf(`${ENDPOINTS.FIREWALL_QUARANTINE_EXPORT}?${buildQuarantineParams(query, false).toString()}`);
}
